import { useAbility } from "@/casl-provider";
import { useVehicleValuationSnapshotDownloadMutation } from "@/common/api/vehicle-valuation/use-vehicle-valuation-snapshot-download.mutation";
import { useVehicleValuationSnapshotQuery } from "@/common/api/vehicle-valuation/use-vehicle-valuation-snapshot.query";
import { DatSnapshotAction, type DatSnapshotTranslations } from "@/components/dat-snapshot/dat-snapshot-action";
import type { ButtonSize } from "@/components/ui/button";
import { VEHICLE_VALUATION_SNAPSHOT_SUBJECT } from "@/modules/fab/vehicle-valuation/vehicle-valuation.permissions";
import { useTranslation } from "react-i18next";

interface VehicleValuationSnapshotActionProps {
  className?: string;
  showInCommandPalette?: boolean;
  size?: ButtonSize;
  valuationUuid: string;
}

export function VehicleValuationSnapshotAction({
  className,
  showInCommandPalette,
  size,
  valuationUuid,
}: VehicleValuationSnapshotActionProps) {
  const { t } = useTranslation("fab");
  const ability = useAbility();
  const translations: DatSnapshotTranslations = {
    description: t("ValuationDatSnapshotDescription"),
    downloadError: t("ValuationDatSnapshotDownloadError"),
    downloaded: t("ValuationDatSnapshotDownloaded"),
    downloadLabel: t("DownloadValuationDatSnapshot"),
    loadErrorDescription: t("ValuationDatSnapshotLoadErrorDescription"),
    loadErrorTitle: t("ValuationDatSnapshotLoadErrorTitle"),
    retryLoad: t("RetryDatSnapshotLoad"),
    title: t("ValuationDatSnapshotTitle"),
    unavailableDescription: t("ValuationDatSnapshotUnavailableDescription"),
    unavailableTitle: t("ValuationDatSnapshotUnavailableTitle"),
    viewLabel: t("ViewValuationDatSnapshot"),
  };

  return (
    <DatSnapshotAction
      canReadSnapshot={ability.can("read", VEHICLE_VALUATION_SNAPSHOT_SUBJECT)}
      className={className}
      showInCommandPalette={showInCommandPalette}
      size={size}
      snapshotUuid={valuationUuid}
      translations={translations}
      useSnapshotDownloadMutation={useVehicleValuationSnapshotDownloadMutation}
      useSnapshotQuery={useVehicleValuationSnapshotQuery}
    />
  );
}
